import React, {Component} from "react";
import styled from "styled-components";
import {X} from "react-feather";
import './mailChimp.css';

import {
  ContainWPadding,
  primary,
  shadow,
  shadowHover,
  LargeTitle,
  SmallMargin,
  InfoParagraph,
  light,
  HugeTitle,
  grayText,
  SplashTitle
} from "../Tools/Variables";

const Wrapper = styled.div `
  transition: 0.5s ease-in-out;
  visibility: ${props => (props.show
  ? "visible"
  : "hidden")};
  opacity: ${props => (props.show
  ? "1"
  : "0")};
  color: ${grayText};
  padding: 10%;
  box-sizing: border-box;
  background: ${primary};
  box-shadow: ${shadowHover};
  max-width: 1500px;
  position: fixed;
  width: 90vw;
  height: 90vh;
  z-index: 9999;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Background = styled.div `
  transition: 1s ease-in-out;
  visibility: ${props => (props.show
  ? "visible"
  : "hidden")};
  opacity: ${props => (props.show
  ? "0.8"
  : "0")};
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #333;
`;

const MailInput = styled.input `
  appearance: none;
  font-family: inherit;
  box-sizing: border-box;
  background: white;
  border: none;
  border: none;
  height: 120px;
  width: 80%;
  box-shadow: none;
  transition: 0.2s ease-in-out;
  padding: 20px;
  line-height: 120;
  font-size: 60px;
  ::placeholder {
    color: ${light};
  }
  :focus {
    box-shadow: ${shadow};
    outline: none;
  }
`;

const Checkbox = styled.div `
  display: inline-block;
  height: 25px;
  width: 25px;
  border: 1px solid black;
  margin-right: 10px;
  vertical-align: sub;
`;

const CloseWrapper = styled.div `
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 0;
  height: 100px;
  width: 100px;
  text-align: center;
  line-height: 100px;
  transition: 0.2s ease-in-out;
  transform-origin: center;
  :hover {
    opacity: 0.5;
    transform: scale(1.1, 1.1);
  }
`;

const SendBtn = styled.div `
    text-transform: uppercase;
    display: inline-block;
    background: black;
    color: white;
    font-weight: 100;
    font-size: 20 px;
    padding: 20px 100px;
    cursor: pointer;
  `;

export class InterestedBody extends Component {
  render() {
    return (
      <React.Fragment>

        <SmallMargin/>

        <SmallMargin/>
        <MailInput placeholder="email" type="email"/>
        <SmallMargin/>
        <InfoParagraph
          style={{
          color: "black",
          maxWidth: 600,
          margin: this.props.center
            ? ' 0 auto'
            : ''
        }}>
          Intresserad? Håll dig uppdaterad om den annalkande sängrevolutionen och få
          förtur på kollektionen.

          <SmallMargin/>
          <div className="clear">
            {" "}
            <Checkbox/>
            att godkänna
          </div>
          <SmallMargin/>
          <SendBtn>Gå Med</SendBtn>
        </InfoParagraph>
      </React.Fragment>
    );
  }
}

class InterestedModal extends Component {
  render() {
    return (
      <React.Fragment>
        <Background show={this.props.showContactModal}/>
        <Wrapper show={this.props.showContactModal}>
          <CloseWrapper onClick={this.props.setHideContactModal}>
            <X/>
          </CloseWrapper>
          <SplashTitle>intresseanmälan</SplashTitle>
          <InterestedBody/>
        </Wrapper>
      </React.Fragment>
    );
  }
}

export default InterestedModal;



// WEBPACK FOOTER //
// ./src/Global/InterestedModal.js